import { Component, OnInit } from '@angular/core';
import { SessionTimeoutOptions, SessionTimeoutService } from '@surescripts/core';
import { Observable, of } from 'rxjs';
import { switchMap, takeWhile, tap } from 'rxjs/operators';
import { AppFacadeService } from '../shared/services/app-facade-service.service';
import { ConfigurationService } from '../shared/services/configuration.service';
import { Product } from './product.model';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  loading$: Observable<boolean>;
  topLevel$: Observable<Product[]>;
  withChildren$: Observable<Product[]>;

  constructor(private facadeService: AppFacadeService,
    private configurationService: ConfigurationService,
    private timeoutService: SessionTimeoutService) { }

  ngOnInit(): void {
    this.loading$ = this.facadeService.isLoading$;
    this.topLevel$ = this.facadeService.topLevelProducts$;
    this.withChildren$ = this.facadeService.productsWithChildren$;

    this.facadeService.productsLoaded$.pipe(
      takeWhile(productsLoaded => !productsLoaded, true),
      switchMap(productsLoaded => {
        if (productsLoaded) {
          return this.configurationService.get();
        }
        return of(null);
      }),
      tap(config => {
        const timeoutConfig = config?.consistentTimeout;
        const timeoutOptions = new SessionTimeoutOptions(timeoutConfig);
        timeoutOptions.appDisplayName = "Workbench";
        if (timeoutConfig?.isEnabled) {
          this.timeoutService.start(timeoutOptions);
        }
      })
    ).subscribe();
  }
}
